import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const plate = css`
  background: linear-gradient(0.25turn, #302f2d, #50504e);
  padding-block: ${spacing(1.5)};
  padding-inline: ${spacing(2, 1.5)};
  border-radius: ${spacing(2)};
  min-inline-size: calc(100vw - ${spacing(2)});
  position: relative;
  left: ${spacing(-1)};
`

export const button = css`
  padding-inline: ${spacing(0.5)};
`

export const title = css`
  color: ${cssTheme.colors.warmGray['200']};
`

export const panelBody = css`
  background: ${cssTheme.colors.deliveryGrey['450']};
`

export const businessSwitch = css`
  background-color: #ffffff33;
  border-radius: ${spacing(2)};
`
